import axios from "@/shared/api/axios";
import { getWorkspaceNameFromUrl } from "@/entities/WorkSpace/api/getWorkspaceId";

export async function workspaceLoader() {
  try {
    const workspaceName = getWorkspaceNameFromUrl();
    if (!workspaceName) return { workspaceData: null };
    const response = await axios.get(`/v1/hub/workspaces/${workspaceName}`);
    return { workspaceData: response.data.data.primaryCompany };
  } catch (error) {
    console.error('워크스페이스 데이터를 불러오는 데 실패했습니다:', error);
    return { workspaceData: null };
  }
}